import { HttpClient } from "@angular/common/http";
import { BaseService } from "../../../shared/Services/BaseService";
import { authenticationService } from "../../../shared/Services/authenticationService";
import { environment } from "../../../../../environments/environment";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { apiConfig } from "../../../../@core/auth/services/apiConfig";

@Injectable({
  providedIn: 'root',
})
export class EventsService extends BaseService {
  constructor(http: HttpClient, authenticationSerives: authenticationService) {
    const baseUrl = environment.apiUrl + 'events';

    super(http, authenticationSerives, baseUrl);
  }


  saveEvent(model):Observable<any>{
    console.log('save event', model)
    return this.http.post( environment.apiUrl + apiConfig.events.add ,model,{ headers: this.getAuthorizationHeader() });
  }
}
